__webpack_require__.p = "/Horoscope_Project_Sass/";